import { Route, Routes } from "react-router-dom";
import TrashSchedule from "./features/trash-schedule/TrashSchedule";
import TrashScheduleView from "./views/TrashScheduleView";

const Routing = () => {
  return (
    <Routes>
      <Route path="" index element={<TrashScheduleView />} />
      <Route path="/:addressId" element={<TrashSchedule />} />
    </Routes>
  );
};

export default Routing;
